<template>
  <div class="header">
      <img class="bjt" src='@/assets/images/bjt.png'/>
      <div class="bjt" style="width: 1900px;height: 350px;position: absolute;z-index: 2;">
        <div class="top_href_a">
          <a @click="gotoUrl('http://www.hyxw.com.cn/')" style="cursor: pointer;">县委</a>
          <div class="divider" type="vertical"></div>
          <a @click="gotoUrl('http://www.hyrd.gov.cn/')" style="cursor: pointer;">县人大</a>
          <div class="divider" type="vertical"></div>
          <!-- <a @click="gotoUrl('https://hanyin.qinfeng.gov.cn/')" style="cursor: pointer;">县纪委监委</a>
          <div class="divider" type="vertical"></div> -->
          <a @click="gotoUrl('https://www.hanyin.gov.cn/')" style="cursor: pointer;">县政府</a>
        </div>
        <input class="searchInput" v-model="searchValue" placeholder="请输入检索内容" @blur="changeValue" @keydown.enter="doSearch"/>
        <img class="searchImg" @click="doSearch" src="@/assets/images/fdj.png" />
      </div>
      <div class="header-nav">
        <div class="header-nav-par">
          <div v-for="(item,index) in nav_list" :key="index" @click="changeNav(item,index)">
            <p :class="active_index == index ? '':''">{{item.title}}</p>
          </div>
        </div>
        <div class="header-nav-par2" style="position: absolute;z-index: -1;">
          <div v-for="(item,index) in nav_list" :key="index" @click="changeNav(item,index)">
            <p :class="active_index == index ? 'active':''" ></p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import NavList from "../../views/common/nav.js"
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      user_type: false,
      active_index:0,
      searchNum:'',
      propId:"",
      searchValue:"",
      nav_list: NavList,
    }
  },
  beforeCreate(to,from){
    console.log('to',to);
    console.log('from',from);
  },
  created() {
    this.loadData()
  },
  computed:{
    getNavIndex(){
      return parseInt(this.$store.state.navIndex)
    }
	},
  watch: {
    getNavIndex(newVal) {
      this.active_index = newVal
    }
  },
  methods: {
    gotoUrl(url){
      window.open(url);
    },
    changeValue(e){
      this.$store.state.searchValue =  this.searchValue   
    },
    // 搜索
    doSearch(){
      // this.gotoView(10,"");
      this.$store.state.searchNum +=1
      this.$router.push({
        path:"/searchFrom",
      })
    },
    // 切换
    changeNav(item,index){


      // this.active_index = -1;
      // if(this.active_index==index){
      //   this.$refs.chidrenFrom.loadData(1);
      // }

      this.active_index = index;
      this.$router.push({
        path:item.path,
      })
    },
    loadData(){ 
      var that = this;
      httpAction("/zxwz/zxwzwzdh/page?type=99&pageSize=5&sffb=1&shzt=02",{},'get').then((res)=>{
        if(res.success){
          that.butDhList = res.result.records;
          console.log("99",res.result);
        }else{
          that.$message.warning(res.message);
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header{
  widows: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .top_href_a{
  position: absolute;
  width: auto;
  left: 382px;
  top: 25px;
  display: flex;

  a{
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
    color: #0671C8;
    letter-spacing: 0;
    margin: auto 5px auto 5px;
  }

  .divider{
    width: 1px;
    height: 17px;
    background: #0671C8;
    margin: auto;
  }
}

  .bjt{
    width: 1920px;
    left: 0px;
    top: 0px;
    z-index: -1;
  }
  &-login{
    width: 100%;
    display: flex;
    padding: 25px 19% 0px 0px;
    margin-bottom: 32px;
    box-sizing: border-box;
    justify-content: flex-end;
    &-y{
      display: flex;
      align-items: center;
      >p:first-child{
        font-weight: 500;
        font-size: 16px;
        color: #3CCDEE;
        letter-spacing: 0;
        text-align: center;
        margin-right: 22px;
      }
      >p:last-child{
        font-weight: 500;
        font-size: 16px;
        color: #6DB4C4;
        letter-spacing: 0;
        text-align: center;
      }
    }
    &-n{
      width: 80px;
      height: 32px;
      background: #10AFD3;
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      p{
        color: white;
      }
    }
  }
  &-nav{
    width: 100%;
    height: 60px;
    background: #2966AE;
    padding: 0 18%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 2;
    
    &-par{
      width: 1270px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: left;
      z-index: 2;

      >div{
        margin: auto;
        width: 37%;
        height: 100%;
        text-align: center;
        display: flex;
        cursor: pointer;
        p{
          font-weight: 600;
          font-size: 21px;
          color: #FFFFFF;
          letter-spacing: 0;
          width: 100%;
          margin: auto;
        }
        
      }

      .active{
          color: #3FDCFF;
          background: #0F4A99;
        }
    }

    &-par2{
      width: 1270px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: left;

      >div{
        margin: auto;
        width: 37%;
        height: 100%;
        text-align: center;
        display: flex;
        p{
          font-weight: 500;
          font-size: 18px;
          color: #FFFFFF;
          letter-spacing: 0;
          cursor: pointer;
          width: 100%;
          margin: auto;
        }
        
      }

      .active{
          color: #3FDCFF;
          background: #0F4A99;
          height: 100%;
        }
    }
  }


  &-bt{
    width: 100%;
    padding-right: 19%;
    margin-top: 126px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    p{
      font-weight: 0;
      font-size: 36px;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
    }
  }
}
.searchInput{
  position: absolute;
  top: 258px;
  left: 1264px;
  width: 280px;
  height: 40px;
  border: 1px solid #7BA8DD;
  border-radius: 2px;
  outline: none;
  background: #00000000;
  padding: 0 10px;
}
.searchInput::placeholder {

  color:#4677B1;
}
.searchImg{
  position: absolute;
  width: 25px;
  height: 24px;
  left: 1516px;
  top: 265px;
  z-index: 2;
  cursor: pointer;
}

</style>
